import { Controller } from '@hotwired/stimulus'

type ValueHolder = {
  value: string
}

/**
 * Controller used to toggle a class in the current element based on the
 * value of another element and fired by a chosen event.
 */
export default class FieldEventClassTogglerController extends Controller<HTMLElement & ValueHolder> {
  declare readonly valueOriginFieldTarget: HTMLElement & ValueHolder
  declare readonly hasEventOriginFieldTarget: boolean
  declare readonly classNameValue: string
  declare readonly eventNameValue: string

  static targets = ['valueOriginField']
  static values = {
    className: {
      type: String,
      default: 'has-value',
    },
    eventName: {
      type: String,
      default: 'change',
    },
  }

  valueOriginFieldTargetConnected(el: HTMLElement) {
    this.#toggleValueMarker()
    el.addEventListener(this.eventNameValue, this.#toggleValueMarker.bind(this))
  }

  valueOriginFieldTargetDisconnected(el: HTMLElement): void {
    el.removeEventListener(this.eventNameValue, this.#toggleValueMarker.bind(this))
  }

  #toggleValueMarker() {
    this.element.classList.toggle(this.classNameValue, Boolean(this.valueOriginFieldTarget.value))
  }
}
